import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Button.scss';

function AppButton(props) {
    let className = "appbtn ";
    if (props.className) className += props.className;
    return (
        <Button className={className}
            onClick={props.onClick}>
            <span className="appbtn-box">
                <FontAwesomeIcon icon={props.icon} />
            </span>
            <span className="appbtn-box">
                {props.btnTxt}
            </span>
        </Button>
    );
}

export default AppButton;